import moment from "moment";
import { Component } from "react";
import Select from "react-select";

const days = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30];

class ExtendOneDayPlan extends Component {

    constructor(props) {
        super(props);
        this.state = {
            numberOfdays: null,
            extendFor: null
        }
    }
    render() {
        const { startDate, endDate, updateDetails, numberofDaysError, extendError, price } = this.props;
        const { numberOfdays, extendFor } = this.state;
        const options = days.map(item => ({ value: item, label: item }));
        const extendedOptions = [{ value: "before", label: `Before ${moment.unix(startDate).format('Do MMM YYYY')}` }, { value: "after", label: `After ${moment.unix(endDate).format('Do MMM YYYY')}` }];

        return <> <div className="row extendplan">
            <div className="col-sm-6">
                <div className="form-group">
                    <label>Starting Date </label>
                    <span className="start_date_old">
                        {" "}{moment.unix(startDate).format('Do MMM YYYY')}</span>
                </div>
            </div>
            <div className="col-sm-6">
                <div className="form-group">
                    <label>Ending Date </label>
                    <span className="end_date_old">
                        {" "}{moment.unix(endDate).format('Do MMM YYYY')} </span>
                </div>
            </div>
            <div className="col-sm-6">
                <label>Add more days</label>
                <Select
                    value={extendFor}
                    onChange={(event) => this.setState({ extendFor: event }, () => updateDetails("beforeafter", event.value))}
                    options={extendedOptions}
                />
                {extendError && <span className="errorMessage required">Please select an option</span>}
            </div>
            <div className="col-sm-6">
                <label>No. of days</label>
                <Select
                    value={numberOfdays}
                    onChange={(event) => this.setState({ numberOfdays: event }, () => updateDetails("numberofdays", event.value))}
                    options={options}
                />
                {numberofDaysError && <span className="errorMessage required">Please select an option</span>}
            </div>
        </div>
            <div className="row">
                <div className="col-sm-12">
                    <div className="form-group">
                        <table className="table">
                            <tbody>
                                <tr>
                                    <td width="70%" className="border-0" align="left"><span id="numberOfDays1" style={{fontSize:'18px',fontWeight:600}}>{numberOfdays ? numberOfdays.value : 0} {(numberOfdays ? numberOfdays.value : 0) > 1 ? 'Days' : 'Day'}</span></td>
                                    <td width="30%" className="border-0" align="right"><span id="price1" style={{fontSize:'18px',fontWeight:600}}>${(numberOfdays ? numberOfdays.value : 0) * price}</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    }
}

export default ExtendOneDayPlan;